import { LinkDescriptor } from "@remix-run/node";
import { useMatches } from "@remix-run/react";

type TDynamicLinksFunction<
  TLoaderData = unknown
> = (
  data: TLoaderData
) => LinkDescriptor[];


export type HandleDynamicLinks<
  TLoaderData = unknown
> = {
  dynamicLinks: TDynamicLinksFunction<TLoaderData>;
};

function isHandleDynamicLinks(
  handle: unknown
): handle is HandleDynamicLinks {
  return (
    handle !== undefined &&
    (handle as HandleDynamicLinks).dynamicLinks !== undefined &&
    typeof (handle as HandleDynamicLinks).dynamicLinks === "function"
  );
}

export function DynamicLinks() {
  const links: LinkDescriptor[] = useMatches().flatMap((match) => {
    if (isHandleDynamicLinks(match.handle)) {
      const fn = match.handle?.dynamicLinks;
      if (typeof fn !== 'function') return [];
      return fn(match.data);
    }

    return []
  });
  if (links.length === 0) {
    return null;
  }
  return (
    <>
      {links.map((link) => (
        <link {...link} key={link.integrity || JSON.stringify(link)} />
      ))}
    </>
  );
}